import { OrderFulfillmentStatus, OrderMethod } from '../../../../../services/exports/Constants';

export default {
  header: 'Ordrehistorik',
  labels: {
    dummy_order: 'Testordre',
    orders_number: 'Antal ordrer ({{count}})',
    revenue: 'Omsætning: {{amount}}',
    tips: 'Drikkepenge: {{amount}}',
    cash_sales: ' ({{amount}} kontant)',
    refunds: 'Refusioner: {{count}} ({{amount}})',
  },
  order_methods: {
    [OrderMethod.Pickup]: 'Afhentning',
    [OrderMethod.Delivery]: 'Levering',
    [OrderMethod.OnSite]: 'Bordbestilling',
  },
  statuses: {
    [OrderFulfillmentStatus.Created]: 'I gang',
    [OrderFulfillmentStatus.Reviewed]: 'I gang',
    [OrderFulfillmentStatus.Accepted]: 'I gang',
    [OrderFulfillmentStatus.Preparing]: 'I gang',
    [OrderFulfillmentStatus.Ready]: 'I gang',
    [OrderFulfillmentStatus.OnDelivery]: 'I gang',
    [OrderFulfillmentStatus.Picked]: 'Gennemført',
    [OrderFulfillmentStatus.Rejected]: 'Afvist',
  },
  payment_methods: {
    invoice: 'Faktura',
    cash: 'Kontant',
    online: 'Online betaling',
  },
  filters: {
    all: 'Alle',
  },
  fields: {
    order_placed: 'Ordre afgivet',
    order_number: '#',
    customer: 'Kunde',
    payment_method: 'Betalingsmetode',
    method: 'Type',
    status: 'Status',
    total: 'I alt',
  },
  buttons: {
    print: 'Udskriv',
    create_test_order: 'Opret testordre',
  },
  toasts: {
    failed_to_fetch_orders: 'Kunne ikke indlæse data. Klik på ikonet „opdater“ eller prøv igen om 1 minut.',
    something_went_wrong: 'Noget gik galt. Prøv igen.',
    failed_to_create_test_order: 'Kunne ikke oprette testordre',
    test_order_created: 'Testordre oprettet',
  },
};
